var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSongbirdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 12C23.999 18.6274 18.6264 24 11.999 24C5.37161 24 -0.000976562 18.6274 -0.000976562 12C-0.000976562 5.37258 5.37161 0 11.999 0C18.6264 0 23.999 5.37258 23.999 12Z",
    fill: "#005BAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07622 5L10.5038 12.4284L13.1134 9.1356L8.07622 5ZM15.023 13.1592L13.2478 9.3372L10.697 12.5964L15.023 13.1592ZM10.6634 12.8064L10.2014 16.2168L14.9082 13.3832L10.6634 12.8064ZM6.92822 19L9.67502 18.272L10.3778 13.1592L6.92822 19ZM14.1606 10.782L15.1966 12.9884L16.3558 9.6704L14.1606 10.782ZM16.5434 9.7572L16.031 11.2552L17.067 12.1932L16.5434 9.7572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongbirdLogo);
export default __webpack_public_path__ + "static/media/songbird-logo.1a1bedbaff57882612694eb801f95b81.svg";
export { ForwardRef as ReactComponent };